<script setup>
import {onMounted, ref} from "vue";
import Button from "../../components/forms/Button.vue";
import {getLoggedUser} from '@/services/AuthService';
import {createConfirmDialog} from "vuejs-confirm-dialog";
import {showSuccessMessage} from "@/helper";
import router from "@/router";
import {useDataTable} from "@/utils/datatableHelper";
import ModalDialog from "@/components/modals/ModalDialog.vue";
import StrategyService from "@/services/StrategyService";
import CreateUpdateStrategyModal from "@/components/modals/CreateUpdateStrategyModal.vue";
import {useI18n} from "vue-i18n";

const {t} = useI18n();

// nastavení tabulky (stránka, počet řádků, řazení, filtry) se pamatuje v localStorage pod klíčem STRATEGIES-INDEX
const datatableRef = ref(null);
const datatable = useDataTable(fetchStrategies, 'strategy_name', 10, true, {}, 'STRATEGIES-INDEX', datatableRef);
const intermediaries = ref(null);
const loggedUser = ref({});

const isEditable = ref(false);

const columns = ref([
  {
    label: t('strategies.name'),
    field: 'name',
    filterOptions: {
      enabled: true,
      skipDiacritics: true,
      placeholder: ' '
    }
  },
  {
    label: t('strategies.code'),
    field: 'code',
    filterOptions: {
      enabled: true,
      skipDiacritics: true,
      placeholder: ' '
    }
  },
  {
    label: t('strategies.is_active'),
    field: 'is_active',
    filterOptions: {
      enabled: true,
      skipDiacritics: true,
      placeholder: ' '
    },
    formatFn: (value) => {
      return value ? t('strategies.yes') : t('strategies.no');
    }
  },
  {
    label: '',
    field: 'action',
    sortable: false,
    html: true
  },
]);

onMounted(() => {
  Promise.all([getLoggedUser()])
      .then(([userResponse]) => {
        loggedUser.value = userResponse;
        if (loggedUser.value.role === 'BACK_OFFICE') {
          isEditable.value = true;
        }
      });
});

function fetchStrategies(body) {
  datatable.isLoading.value = true;
  StrategyService.fetchRecords(body).then(response => {
    datatable.totalRecords.value = response.meta.total;
    datatable.rows.value = response.data;
    datatable.isLoading.value = false;
  });
}

function createStrategy() {
  const {reveal, onConfirm, onCancel} = createConfirmDialog(CreateUpdateStrategyModal, {});
  reveal();
  onConfirm((data) => {
    StrategyService.saveStrategy(data).then(response => {
      showSuccessMessage(response.message);
      fetchStrategies(datatable.body);
    });
  });
  onCancel(() => {
  });
}
</script>

<template>
  <div class="page-section">
    <div class="page-section__heading">
      <div class="row">
        <div class="col-3">
          <a @click="router.back()" class="page-section__heading__back"><i class="mdi mdi-arrow-left"></i> {{ t('general.back')}}</a>
        </div>
        <div class="col-5 text-center">
          <div class="page-section__title">
            {{ t('strategies.strategy') }}
          </div>
        </div>
        <div class="col-4 d-flex justify-content-end">
          <Button :label="t('strategies.add_strategy')" icon="mdi-text-box-plus" @click="createStrategy()"></Button>
        </div>
      </div>

    </div>
  </div>
  <div class="page-section__content">
    <div class="mt-3">
      <vue-good-table
          ref="datatableRef"
          :sort-options="{enabled: true, initialSortBy: datatable.initialSortBy.value}"
          :columns="columns"
          :rows="datatable.rows.value"
          mode="remote"
          @page-change="datatable.onPageChange"
          @sort-change="datatable.onSortChange"
          @column-filter="datatable.onColumnFilter"
          @per-page-change="datatable.onPerPageChange"
          :totalRows="datatable.totalRecords.value"
          :pagination-options="{
                  enabled: true,
                  rowsPerPageLabel: t('strategies.entriesPerPage'),
                  nextLabel: t('strategies.next'),
                  prevLabel: t('strategies.previous'),
                  ofLabel: t('strategies.of'),
                }">
        <template #table-row="props">
                            <!-- IMA-517: strategie typu Dluhopisy je v seznamu poznat podle štítku -->
                            <span v-if="props.column.field === 'name'">
                                {{ props.row.name }}
                                <span v-if="props.row.product_type === 'BOND'" class="badge bg-primary fw-normal ms-1">{{ t('createUpdateStrategyModal.product_type_bond') }}</span>
                            </span>
                            <span v-else-if="props.column.field == 'action'">
                                <span style="font-weight: bold; float: right">
                                    <router-link :to="{ name: 'StrategyDetail', params: { id: props.row.id} }"><button type="button" class="btn btn-link"><i class="mdi mdi-eye"/></button></router-link>
                                    </span>
                            </span>
        </template>
        <template v-slot:emptystate v-if="!datatable.isLoading.value">
          <div class="text-center">
            {{ t('strategies.no_records_found') }}
          </div>
        </template>
        <template v-slot:emptystate v-if="datatable.isLoading.value">
          <div class="text-center">
            {{ t('strategies.data_loading') }}
          </div>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<style scoped>

</style>
